import axios from "axios"
import { fetchAccessToken } from "../utils/token"
import { BRIDGE_URL } from "../utils/constants"
import { getSendEmail } from "./getSendEmail";

// Cancel appointment
export const patchCancelAppointment = async (appointmentId, customerEmail = null) => {

    try {

        const token = localStorage.getItem("oss-token")
        if(!token) fetchAccessToken()

        const headers = {
            Authorization: `Bearer ${token}`
        }

        const res = await axios.patch(`${BRIDGE_URL(`services/apexrest/appointment/cancel/?appointmentId=${appointmentId}`)}`, {}, { headers })

        console.log(res.data);
        console.log('cancel');
        // if(res.data.status == 'Cancelled'){
        //     const emailResponse = await getSendEmail(customerEmail, "cancelled", appointmentId);
        //     console.log(emailResponse);
        // }

        return res.data

    } catch (err) {
        console.log(err)
    }

}